module.exports = __webpack_public_path__ + "img/edv.7dd0f94b.png";